import React, { createContext, useCallback, useEffect, useState } from 'react';
import axios from 'axios';

export const DbEntryDateContext = createContext({
  dbEntryDate: null,
  refreshDbEntryDate: () => {},
});

export const DbEntryDateProvider = ({ children }) => {
  const [dbEntryDate, setDbEntryDate] = useState(null);

  const fetchDbEntryDate = useCallback(async () => {
    try {
      const res = await axios.get('/api/reports/db-entry-date');
      const val = res?.data?.dbEntryDate ?? res?.data?.date ?? res?.data ?? null;
      setDbEntryDate(val ? String(val) : null);
    } catch (err) {
      setDbEntryDate(null);
    }
  }, []);

  useEffect(() => {
    fetchDbEntryDate();
  }, [fetchDbEntryDate]);

  return (
    <DbEntryDateContext.Provider value={{ dbEntryDate, refreshDbEntryDate: fetchDbEntryDate }}>
      {children}
    </DbEntryDateContext.Provider>
  );
};